<!--
 * @Descripttion:
 * @version:
 * @Author: lfs
 * @Date: 2024年04月10日 09:02:12
-->
<template>
  <div class="tab">
    <ul class='atb-flex '>
      <li
        @click='clickSlide(index, item)' :class="[tabIndex == item.id ? 'slide-tab' : '', iconStyle === 'top' ? 'top' : '']" class="atb-flex atb-flex-justify-center atb-flex-items-center" v-for="(item, index)
         in
        tabList"
        :key="item.label +
      Math.random()">{{item.label }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true,
      },
      tabIndex: '0'
    };
  },
  computed: {},
  props: {
    tabList: {
      default: new Array(),
      type: Array,
    },
    defaultIndex: {
      type: String,
      default: '0'
    },
    iconStyle:{
      type: String,
      default: 'bottom'
    }
  },
  methods: {
    clickSlide(index, item) {
      this.tabIndex = item.id;
      this.$emit('getCurrent', {index: index, data: item});
    },
  },
  watch: {
    defaultIndex: {
      handler(val) {
        this.tabIndex = val;
      },
    }
  }
};
</script>

<style scoped lang="scss">
.tab {
  ul {
    /*height: 88px;*/
    padding-left: 23px;
  }
  li {
    font-size: 17px;
    color: #859291;
    position: relative;
    margin-right: 40px;
    padding-bottom: 14px;
    cursor: pointer;
    line-height: 1;
    &.slide-tab {
      color: $--color-text-title;
      font-weight: bold;
    }
    &.top{
      padding-bottom: 24px;
    }
    &.slide-tab::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -8px;
      width: 20px;
      height: 4px;
      background: $--color-primary;
      border-radius: 5px;
    }
    &.slide-tab.top::after{
      top: -20px;
    }
  }
}
</style>
